<template>
    <footer class="footer has-cards">
        <div class="container">
<!--          <div class="logo_head_call mobile_min" style="position: absolute; right: 250px; z-index: 100;">-->
<!--            <a @click="dialogVideoVisible = true">-->
<!--              <div class="icon_submenu_bir">-->
<!--                <img-->
<!--                    src="../../public/video/saylov_2021.png"-->
<!--                    style="width: 200px; margin-top: 15px;"-->
<!--                />-->
<!--              </div>-->
<!--            </a>-->
<!--          </div>-->
          <div class="logo_head_call mobile_min" style="position: absolute; right: 0; z-index: 100;">
<!--            <a href="https://uzbekcoders.uz/" target="_blank">-->
            <a @click="dialogTableVisible = true">
              <div class="icon_submenu_bir">
                <img
                    src="../../public/img/bir_md.png"
                    style="height: 42px; margin-top: 37px;"
                />
              </div>
            </a>
          </div>
            <el-row :gutter="15">
                <el-col :sm="24" :md="12" :lg="4" class="footer_logo_title">
                    <img src="img/brand/pro_logo_line.svg" class="img-fluid" style="margin: auto; width: 80px;">
                    <strong>{{$t('app.bosh_pro')}}
                        <span style="text-transform: none; display: block;">{{$t('app.bosh_res')}}</span></strong>
                        <span class="footer_logo_text">{{$t('app.footer_enter')}}</span>
                        <span class="footer_logo_text">{{$t('app.footer_res')}}</span>
                </el-col>
                <el-col :sm="16" :md="12" :lg="8">
                        <span class="footer_logo_text_left_area mobile_footer_mini" v-html="$t('app.bosh_text')"></span>
                </el-col>
                <el-col :sm="12" :md="8" :lg="3" class="footer_logo_link mobile_footer">
                        <router-link to="/pressservice">{{$t('app.bosh_link')}}</router-link>
                        <router-link to="/rahbariyat">{{$t('submenu.leaders')}}</router-link>
                        <router-link to="/tuzilma">{{$t('menu.pro_structure')}}</router-link>
                        <router-link to="/taskfunction">{{$t('submenu.task_main')}}</router-link>
                        <router-link to="/hujjatlar">{{$t('menu.pro_normative')}}</router-link>
                        <router-link to="/kadrlar">{{$t('submenu.staff')}}</router-link>
<!--                        <router-link to="/sectornews">{{$t('app.bosh_link6')}}</router-link>-->
                </el-col>
                <el-col :sm="12" :md="8" :lg="3" class="footer_logo_link mobile_footer">
                        <a href="#">{{$t('app.bosh_region')}}</a>
                        <a href="#">{{$t('app.bosh_region1')}}</a>
                        <a href="#">{{$t('app.bosh_region2')}}</a>
                        <a href="#">{{$t('app.bosh_region3')}}</a>
                        <a href="#">{{$t('app.bosh_region4')}}</a>
                        <a href="#">{{$t('app.bosh_region5')}}</a>
                        <a href="#">{{$t('app.bosh_region6')}}</a>
                </el-col>
                <el-col :sm="12" :md="8" :lg="3" class="footer_logo_link mobile_footer">
                        <a href="#">{{$t('app.bosh_region7')}}</a>
                        <a href="#">{{$t('app.bosh_region8')}}</a>
                        <a href="#">{{$t('app.bosh_region9')}}</a>
                        <a href="https://tshp.uz/uz_UZ/">{{$t('app.bosh_region10')}}</a>
                        <a href="https://tvp.uz/">{{$t('app.bosh_region11')}}</a>
                        <a href="#">{{$t('app.bosh_region12')}}</a>
                        <a href="#">{{$t('app.bosh_region13')}}</a>
                </el-col>
                <el-col :sm="12" :md="8" :lg="3" class="footer_logo_link mobile_footer">
                    <strong>{{$t('app.bosh_statis')}}</strong>
                    <span><strong class="footer_row_l">{{$t('app.bosh_stat')}}</strong>  <span v-if="visitCount">{{visitCount.countAll}}</span></span>
                    <span><strong class="footer_row_l">{{$t('app.bosh_stat1')}}</strong>  <span v-if="visitCount">{{visitCount.countToday}}</span></span>
                    <span><strong class="footer_row_l">{{$t('app.bosh_stat2')}}</strong>  <span v-if="visitCount">{{visitCount.countYest}}</span></span>
                    <span><span class="footer_row_l">{{$t('app.bosh_stat3')}}</span>  <span v-if="visitCount">{{visitCount.countWeek}}</span></span>
                    <span><span class="footer_row_l">{{$t('app.bosh_stat4')}}</span>  <span v-if="visitCount">{{visitCount.countMonth}}</span></span>
                </el-col>
            </el-row>
          <el-dialog :visible.sync="dialogVideoVisible">
            <video playsinline controls autoplay src="../../public/video/aoka_cloud.mp4" type="video/mp4" style="width: 100%; margin-bottom: -6px;"></video>
          </el-dialog>
          <el-dialog :visible.sync="dialogTableVisible">
            <img src="../../public/img/banner_5.jpg" style="width: 100%;">
          </el-dialog>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear(),
      visitCount: null,
      dialogTableVisible: false,
      dialogVideoVisible: false
    }
  },
    methods: {
      loadVisitCount() {
          // this.$axios.get(`http://172.18.45.189:8080/api/visit/get-count-by-group`).then(response => {
          this.$axios.get(`https://www.prokuratura.uz/api/visit/get-count-by-group`).then(response => {
              this.visitCount = response.data;
          });
      }
    },
    created() {
        this.loadVisitCount();
    }
};
</script>
<style scoped>


    a {
        color: #fff;
    }

    a:hover {
        color: #96b4d3;
        text-decoration: none;
    }
    /deep/ .el-dialog__header {
      padding: 0px;
    }
    /deep/ .el-dialog__body {
      padding: 0px;
      color: #606266;
      font-size: 14px;
      word-break: break-all;
    }
</style>
